module.exports = __webpack_public_path__ + "d8352e5b50388c9290014acd9ac74793.svg";